import httpClient from '@/lib/httpClient'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useChangeTransactionDate() {
  const queryClient = useQueryClient()

  const action = async ({
    id,
    transactionDate,
  }: {
    id: number
    transactionDate: string
  }) => {
    const response = await httpClient.patch(
      `/team/cash-flow/transfers/${id}/change-date`,
      {
        transaction_date: transactionDate,
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Transaction date changed')
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
    },
    onError: (error, variables) => {
      toast.error(error?.response?.data?.message ?? 'An error occurred.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
